import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import AthletesTable from "../athlete/AthletesTable";
import { AthleteFields } from "../athlete/AthleteFields";
import { useEffect, useState } from "react";
import { gql, useMutation } from "@apollo/client";
import { setUser } from "../../redux/features/userSlice";
import { toast } from "react-toastify";
import { setAppState } from "../../redux/features/appStateSlice";

export default function CompleteUserProfileModal() {
  const appState = useSelector((state) => state.appState);
  const user = useSelector((state) => state.user);

  const [step, setStep] = useState(0);

  useEffect(() => {
    if (user?.firstname && user?.lastname) {
      setStep(1);
    } else {
      setStep(0);
    }
  }, [user]);

  return (
    <Modal show={appState.showCompleteUserProfileModal} size="lg">
      <Modal.Header>
        <Modal.Title>{"Complétez votre profil"}</Modal.Title>
      </Modal.Header>
      {step === 0 && <Step0 user={user} />}
      {step === 1 && <Step1 user={user} />}
    </Modal>
  );
}

const Step0 = ({ user }) => {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const dispatch = useDispatch();

  const [saveMe, { loading: saveMeLoading }] = useMutation(
    gql`
      mutation save_me($input: SaveMeInput!) {
        save_me(input: $input) {
          id
        }
      }
    `
  );
  return (
    <>
      <Modal.Body className="pb-3">
        <div className="alert alert-secondary">
          Veuillez compléter votre profil en renseignant votre prénom et votre
          nom pour pouvoir continuer.
        </div>
        <div className="form-field mb-3">
          <label htmlFor="firstname" className="form-label">
            Email
          </label>
          <input
            type="text"
            className="form-control"
            disabled={true}
            value={user?.email}
          />
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-field mb-3">
              <label htmlFor="firstname" className="form-label">
                Prénom
              </label>
              <input
                type="text"
                className="form-control"
                id="firstname"
                value={firstname}
                onChange={(e) => setFirstname(e.target.value)}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-field mb-3">
              <label htmlFor="lastname" className="form-label">
                Nom
              </label>
              <input
                type="text"
                className="form-control"
                id="lastname"
                value={lastname}
                onChange={(e) => setLastname(e.target.value)}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-primary"
          disabled={!firstname || !lastname || saveMeLoading}
          onClick={async () => {
            const res = await saveMe({
              variables: {
                input: {
                  id: user.id,
                  firstname,
                  lastname,
                },
              },
            });

            if (res.data.save_me) {
              dispatch(setUser({ ...user, firstname, lastname }));
            } else {
              toast.error(
                "Une erreur est survenue lors de la modification de votre compte"
              );
            }
          }}
        >
          Sauvegarder
        </button>
      </Modal.Footer>
    </>
  );
};

const Step1 = ({ user }) => {
  const [fullname, setFullname] = useState("");
  const dispatch = useDispatch();
  useEffect(() => {
    setFullname(`${user.firstname} ${user.lastname}`);
  }, [user]);
  return (
    <>
      <Modal.Body className="pb-3">
        <div className="alert alert-secondary">
          Vous n'avez pas encore lié votre profil à un athlète. Vous pouvez le
          faire en cliquant en recherchant votre profil d'athlète, et en le
          sélectionnant.
        </div>
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Rechercher votre profil d'athlète"
            value={fullname}
            onChange={(e) => setFullname(e.target.value)}
          />
        </div>
        <div style={{ height: "500px" }}>
          {fullname.length > 3 && (
            <AthletesTable
              fields={[
                AthleteFields.fullname_no_link,
                AthleteFields.club_no_link,
                AthleteFields.category,
                AthleteFields.action_assign_to_user,
              ]}
              showHeader={false}
              showFilters={false}
              rows={10}
              defaultFilter={{ fullname }}
              showPagination={true}
            />
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-primary"
          onClick={() => {
            dispatch(setAppState({ showCompleteUserProfileModal: false }));
          }}
        >
          Passer cette étape
        </button>
      </Modal.Footer>
    </>
  );
};
